<template>
    <div class="Head">
        <section>
            <img  class="logo" src="/imgs/logo.png" alt="" @click="handleIndex"/>
            <ul class="nav-ul hidden-xs-only">
                <li
                    v-for="(item, idx) of navs"
                    :key="'n' + idx"
                    @click="handleNav(item)"
                >
                    <p>{{ item.title }}</p>
                    <span :class="cur == item.name ? 'cur' : ''"></span>
                </li>
            </ul>
            <img 
                class="menu hidden-sm-and-up"
                src="/imgs/menu.png"
                alt=""
                @click="handleDrawer"
            />
        </section>
        <div class="head-drawer hidden-sm-and-up" :style="drawer?'height:calc(100vh - 5.6rem);':'height:0;'" >
            <ul class="menu-ul">
                <li
                    v-for="(item, idx) of navs"
                    :key="'n' + idx"
                    @click="handleNavDrawer(item)"
                    :class="hasSubitemsClass(item)"
                >
                    <p>{{ item.title }}</p>
                    <div></div>
                    <!-- 添加二级分类 -->
                    <ul v-if="item.showSubItems && item.subItems && item.subItems.length" id="sub-menu">
                        <li v-for="(subItem, subIdx) of item.subItems" :key="'s' + subIdx" @click.stop="handleSubNav(subItem)" id="sub-menu-container">
                            <p>{{ subItem.name }}</p>
                        </li>
                    </ul>
                    
                </li>
            </ul>
            <div @click="handleDrawer" ></div>
        </div>
    </div>
</template>
<script>
export default {
    name: "Head",
    components: {},
    data() {
        return {
            cur: "",
            navs: [
                {
                    title: "首页",
                    path: "/",
                    name:"Home",
                },
                {
                    title: "关于傲天",
                    path: "/about",
                    name:"About"
                },
                {
                    title: "新闻动态",
                    path: "/news/0",
                    name:"News"
                },
                {
                    title: "产品系列",
                    path: "/product",
                    name:"Product",
                    subItems: [
                        {id: 'cplx1', name: '血站产品', path: "/product?productType=" },
                        {id: 'cplx2', name: '临床产品', path: "/product?productType=" },
                    ],
                    showSubItems: false
                },
                {
                    title: "成功案例",
                    path: "/successful",
                    name:"Successful"
                },
                {
                    title: "加入我们",
                    path: "/contact",
                    name:"Contact"
                },
            ],
            drawer: false,
        };
    },
    methods: {
        handleIndex(){
            location.href="/"
        },
        handleNav(e) {
            const that = this
            if(this.cur==e.name){
                location.href=e.path
                // this.drawer = false
                // document.body.parentNode.style.overflowY ="auto"
            }else{
                // location.href=e.path
                this.cur = e.name;
                this.drawer = false
                document.body.parentNode.style.overflowY ="auto"
                that.$router.push(e.path);
            }
        },
        handleNavDrawer(e) {
            const that = this
            if(e.subItems && e.subItems.length){
                e.showSubItems = !e.showSubItems;
            } else {
                if(this.cur==e.name){
                    location.href=e.path
                    // this.drawer = false
                    // document.body.parentNode.style.overflowY ="auto"
                }else{
                    // location.href=e.path
                    this.cur = e.name;
                    this.drawer = false
                    document.body.parentNode.style.overflowY ="auto"
                    that.$router.push(e.path);
                }
            }
        },
        handleDrawer(){
            this.drawer =! this.drawer;
            if(this.drawer){
                document.body.parentNode.style.overflowY ="hidden"
            }else{
                document.body.parentNode.style.overflowY ="auto"
            }
        },
        hasSubitemsClass(item) {
            return item.subItems && item.subItems.length && item.showSubItems ? 'has-subitems-menu' : 'no-has-subitems-menu';
        },
        handleSubNav(subItem) {
            location.href=subItem.path + subItem.id
        }
    },
    created() {},
    mounted() {
        this.cur = this.$route.name;
        if(this.$route.query.nav){
            this.cur = this.$route.query.nav;
        }
    },
    beforeUnmount() {},
    watch:{
        $route(newVal,oldVal){
            this.cur = this.$route.name;
            if(this.$route.query.nav){
                this.cur = this.$route.query.nav;
            }
        }
    }
};
</script>
<style lang="less" scoped>

.no-subitems-menu {
    margin-bottom: 0px;
}

.has-subitems-menu {
    margin-bottom: 80px;
}

#sub-menu {
    position: absolute;
    margin-bottom: 100px;
    list-style: none;
    width: 100vw;
}

#sub-menu-container {
    position: relative;
    margin: 0;
    padding: 0;
    margin-left: -1.6rem;
    margin-right: 5rem;
    border-bottom: 1px solid rgb(167, 167, 167);
    height: 40px;
    line-height: 40px;
}

.Head {
    position: fixed;
    z-index: 9999;
    left: 0;
    top: 0;
    width: 100vw;
    height: 5.6rem;
    background: #fff;
    > section {
        max-width: 67rem;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 100%;
        .logo {
            margin: 0 5rem 0 2rem;
            width: 9rem;
            cursor: pointer;
        }
        .menu {
            margin-right: 2rem;
            width: 30px;
            padding: 3px;
            border-radius: 3px;
            &:active {
                background: #dddddd;
            }
        }
        .nav-ul {
            display: flex;
            list-style: none;
            justify-content: space-between;
            width: 100%;
            margin: 0;
            > li {
                margin: 0;
                padding: 0;
                width: 5.6rem;
                height: 5.6rem;
                font-size: 1rem;
                font-weight: 400;
                cursor: pointer;
                text-align: center;
                > p {
                    margin: 0;
                    line-height: calc(5.6rem - 3px);
                    height: calc(5.6rem - 3px);
                }
                > span {
                    display: block;
                    width: 0;
                    height: 3px;
                    background: #0f45f9;
                    transition: all 0.3s ease;
                    margin-top: -1.8rem;
                    // margin: 0 auto;
                    opacity: 0;
                }
                .cur {
                    width: 5.6rem;
                    opacity: 1;
                }
            }
        }
    }
    .head-drawer {
        color: #000;
        box-sizing: border-box;
        height: 0;
        width: 100vw;
        overflow: hidden;
        transition: all 0.3s ease;
        position: relative;
        .menu-ul {
            list-style: none;
            width: 100vw;
            margin: 0;
            padding: 0;
            background-color: #fff;
            position: absolute;
            top:0;
            left: 0;
            z-index: 2;
            li {
                // padding: 0;
                // margin: 0;
                font-size: 1.5rem;
                height: 50px;
                line-height: 50px;
                p {
                    margin: 0;
                    margin: 0 20px;
                    border-bottom: 1px solid rgb(167, 167, 167);
                    box-sizing: border-box;
                    &:last-child{
                        border: none;
                    }
                }
                // &:active {
                //     background: rgba(#000, 0.3);
                // }
            }
        }
        >div{
            background-color: rgba(#000,0.3);
            height: 100%;
            min-width: 100vw;
            position: absolute;
            top:0;
            left: 0;
            z-index: 1;
        }
    }
}
</style>
